import * as S from "./styles.ts";
import { RadioBlob, Skeleton } from "@template/components";

export type TItem = {
  key: string | number;
  label: any;
  subheading?: any;
  loading?: boolean;
  selected?: boolean;
};

interface ITableCardProps {
  item: TItem;
  onSelect: () => void;
}

const TableCard = ({ item, onSelect }: ITableCardProps) => {
  return (
    <Skeleton
      style={{
        width: "100%",
        height: "100%",
      }}
      opaque
      hideSkeleton={!item.loading}
    >
      <S.CardContainer
        onClick={() => !item.loading && onSelect()}
        $selected={item.selected}
        data-is-selected={item.selected}
      >
        <S.CardTextContainer>
          <S.CardLabel>{item.label}</S.CardLabel>
          {item.subheading && (
            <S.CardSubheading>{item.subheading}</S.CardSubheading>
          )}
        </S.CardTextContainer>
        <RadioBlob
          selected={item.selected}
          variant="check-circle"
          size="md"
        />
      </S.CardContainer>
    </Skeleton>
  );
};

export default TableCard;
